import mountApp    from 'cfg/mountApp';
import ContactForm from './Vue/ContactForm.vue';


export default (selector, options = {})=> {
  const vueOptions = {
    translationDomain: 'contact',
    components: { ContactForm },
    data() {
      return {
        reasons: options.reasons || [],
      };
    },
  };

  return mountApp({...options, ...vueOptions}, selector);
};
